function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9 10C6.533 10 4.517 7.985 4.517 5.517C4.517 3.049 6.533 1 9 1C11.467 1 13.483 3.015 13.483 5.483C13.483 7.951 11.467 10 9 10ZM16 19H2C1.45 19 1 18.55 1 18V17C1 14.8 2.8 13 5 13H13C15.2 13 17 14.8 17 17V18C17 18.55 16.55 19 16 19Z",
  fill: "#4E525D"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9 9.25C6.9471 9.25 5.267 7.57068 5.267 5.517H3.767C3.767 8.39932 6.1189 10.75 9 10.75V9.25ZM5.267 5.517C5.267 3.45594 6.95445 1.75 9 1.75V0.25C6.11155 0.25 3.767 2.64206 3.767 5.517H5.267ZM9 1.75C11.0529 1.75 12.733 3.42932 12.733 5.483H14.233C14.233 2.60068 11.8811 0.25 9 0.25V1.75ZM12.733 5.483C12.733 7.54406 11.0456 9.25 9 9.25V10.75C11.8884 10.75 14.233 8.35794 14.233 5.483H12.733ZM16 18.25H2V19.75H16V18.25ZM2 18.25C1.86421 18.25 1.75 18.1358 1.75 18H0.25C0.25 18.9642 1.03579 19.75 2 19.75V18.25ZM1.75 18V17H0.25V18H1.75ZM1.75 17C1.75 15.2142 3.21421 13.75 5 13.75V12.25C2.38579 12.25 0.25 14.3858 0.25 17H1.75ZM5 13.75H13V12.25H5V13.75ZM13 13.75C14.7858 13.75 16.25 15.2142 16.25 17H17.75C17.75 14.3858 15.6142 12.25 13 12.25V13.75ZM16.25 17V18H17.75V17H16.25ZM16.25 18C16.25 18.1358 16.1358 18.25 16 18.25V19.75C16.9642 19.75 17.75 18.9642 17.75 18H16.25Z",
  fill: "#4E525D"
});

var SvgUser = function SvgUser(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user.c4368060.svg";
export { ForwardRef as ReactComponent };